import type { SpectralLineData } from "../types";
import { MAX_THICKNESS_MULTIPLIER } from "./settings";

export function bunch(lines: SpectralLineData[], thresholdNm: number): SpectralLineData[] {
  if (thresholdNm <= 0) return lines;

  const dead = new Array<boolean>(lines.length).fill(false);

  for (let i = 0; i < lines.length; i++) {
    if (dead[i]) continue;
    for (let j = 0; j < lines.length; j++) {
      if (i === j || dead[j]) continue;
      if (Math.abs(lines[i].wavelengthNm - lines[j].wavelengthNm) <= thresholdNm) {
        if (lines[i].intensity <= lines[j].intensity) {
          lines[j].thicknessMultiplier = Math.min(
            lines[j].thicknessMultiplier + lines[i].thicknessMultiplier,
            MAX_THICKNESS_MULTIPLIER,
          );
          dead[i] = true;
          break;
        }
      }
    }
  }

  return lines.filter((_, i) => !dead[i]);
}
